import { Blocks as ItemContainerBlocks, Component as ItemContainerComponent, TypeConfig as ItemContainerTypeConfig } from './ItemContainer.jsx';
import { Tokens as ItemMetaTokens } from './ItemMeta.jsx';
import * as ListTitle from '../common/ListTitle.jsx';
import Name from '../utility/Name.jsx';

const Blocks = {
    get: (group, data) => [
        {
            id: 'mosaicSeparator',
            dataType: 'separator',
            display: 'Mosaic',
            group
        },
        {
            id: Name.Block.ListTitle,
            component: ListTitle.Component,
            config: {
                Block: ListTitle.TypeConfig.panel.block(true),
                Visibility: ListTitle.TypeConfig.panel.visibility({ configurableDuringExport: (type) => type == 'mosaics' }),
                Style: ListTitle.TypeConfig.panel.style()
            },
            display: 'List Title\n(Quicklists Only)',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Container,
            component: ItemContainerComponent,
            config: {
                Block: ItemContainerTypeConfig.panel.block(),
                Style: ItemContainerTypeConfig.panel.style(),
                Visibility: ItemContainerTypeConfig.panel.visibility(),
                defaults: [
                    { configName: 'Block', propertyName: 'design', propertyValue: ItemContainerTypeConfig.defaultDesign(data) }
                ]
            },
            display: 'Item Container',
            group,
            image: '',
            type: 'container'
        }
    ]
};
const Content = {
    [Name.Block.Inventory.Container]: ItemContainerBlocks
};
const Tokens = {
    get: (id, data) => {
        switch (id) {
            case Name.Block.Inventory.Meta:
                return ItemMetaTokens(data);
            case Name.Block.ListTitle:
                return ListTitle.Tokens();
        }
    }
};

export {
    Blocks,
    Content,
    Tokens
}